import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-painel-confirmation-modal',
  templateUrl: './painel-confirmation-modal.component.html',
  styleUrls: ['./painel-confirmation-modal.component.scss']
})
export class PainelConfirmationModalComponent {

  constructor(
    public dialogRef: MatDialogRef<PainelConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  closeDialog() {
    this.dialogRef.close(false);
  }
  confirm() {
    this.dialogRef.close(true);
  }

}
